import React from 'react';
import './SubmitSuccess.css';

function SubmitSuccess(props) {
    return (
            <div className="SubmitSuccess">
                <h1 className="SubmitSuccess-title">{props.formTitle}</h1>
                <div className="SubmitSuccess-container">
                    <h2 className="SubmitSuccess-msg-title">{props.successTitle}</h2>
                    <p className="SubmitSuccess-msg">{props.successMsg}</p>
                    <p className="SubmitSuccess-email">{props.email}</p>
                </div>
            </div>
    );
}

export default SubmitSuccess;


// WEBPACK FOOTER //
// ./src/components/SubmitSuccess/SubmitSuccess.js